module.exports = __webpack_public_path__ + "img/01_maska_mazok_1.9e25d58.svg";